<!-- <div fxLayoutGap="20px" class="card card-class"> -->

<form [formGroup]="modifierForm">
  <h1 mat-dialog-title>Diffculty Modifiers</h1>
  <div mat-dialog-content>
    <p>
      <mat-form-field appearance="fill">
        <mat-label>Select Diffculty</mat-label>
        <mat-select formControlName="QuestionDifficulty_SysRef">
          <mat-option *ngFor="let q of (dataQuestionDifficultyList$ | async)" [value]="q.sysRef">
            {{q.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </p>
    <p>
      <mat-form-field appearance="fill">
        <mat-label>Select Level</mat-label>
        <mat-select formControlName="Level_SysRef">
          <mat-option *ngFor="let level of (dataLevelList$ | async)" [value]="level.sysRef">
            {{level.description}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </p>
  </div>
  <div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">Close</button>
    <button mat-button [mat-dialog-close]="" cdkFocusInitial (click)="Add()">Save</button>
  </div>
</form>
